var classes = {
  "tile-buttons": "tile-buttons__siphW"
};
export { classes as default };